import fetch from '@/utils/fetch';

export function getGmpTree(params){

     return fetch({

         url: '/Service/Api/jd?service=ManageRuleService&method=getOrganizationAndPostTree&param=BaseParameter',
         method:"post",
         data:params

     })

}

export function getUserList(params){

     return fetch({

         url: '/Service/Api/jd?service=ManageUserService&method=getUserListByOrganizationId&param=OrganizationUserListParam',
         method:"post",
         data:params

     })

}

export function getRoles(params){

     return fetch({

         url: '/Service/Api/jd?service=ManageRuleService&method=getOrganizationAndPostList&param=GetOrganizationAndPostListParam',
         method:"post",
         data:params

     })

}

export function getConfiged(params){

     return fetch({

         url: 'ManageRule/ManageRule/getUserPostRuleTree',
         method:"post",
         data:params

     })

}


export function userConnectRole(params){     //  账号角色绑定

     return fetch({
         url: 'ManageUser/ManageUser/updateOrganizationUser',
         method:"post",
         data:params

     })

}

export function userCreate(params){     //  账号新建

     return fetch({
         url: 'ManageUser/ManageUser/registerOrganization',
         method:"post",
         data:params

     })

}

export function userUpdate(params){     //  账号新建

    return fetch({
        url: 'ManageUser/ManageUser/updateOrganizationUser',
        method:"post",
        data:params

    })

}

export function userRemove(params){     //  账号删除

     return fetch({
         url: 'ManageUser/ManageUser/delOrganizationUser',
         method:"post",
         data:params

     })

}


export function getUserRoles(params){     //  账号删除

     return fetch({
         url: '/Service/Api/jd?service=ManageUserService&method=getOrganizationUserByUserId&param=OrganizationUserParam',
         method:"post",
         data:params

     })

}

export function resetPasswordFormAdmin(params){     //  账号删除

    return fetch({
        url: 'ManageUser/ManageUser/resetPasswordFormAdmin',
        method:"post",
        data:params

    })

}

export function saveUserRegister(params){     //  账号删除

    return fetch({
        url: 'ManageUser/ManageUser/saveUserRegister',
        method:"post",
        data:params

    })

}


export function requestSmsCode(params){     //  账号删除

    return fetch({
        url: 'User/User/requestSmsCodeByApp',
        method:"post",
        data:params

    })

}

export function getUserRegisterWhereByFileds(params){     //  账号删除

    return fetch({
        url: 'ManageUser/ManageUser/getUserRegisterWhereByFileds',
        method:"post",
        data:params

    })

}

export function getUserRegisterById(params){     //  账号删除

    return fetch({
        url: 'ManageUser/ManageUser/getUserRegisterById',
        method:"post",
        data:params

    })

}
export function getPostList(params){     //  账号删除

    return fetch({
        url: 'ManageRule/ManageRule/getPostList',
        method:"post",
        data:params

    })

}
// 校验短信验证码
export function codeCheck(params) {
    return fetch({
      url: 'User/User/verifySmsCode',
      method: "post",
      data: params
    });
  }
  
  
  // 专家重置密码
  export function registerRecode(params) {
    return fetch({
      url: 'ManageUser/ManageUser/resetPassword',
      method: "post",
      data: params
    });
  }
  
   // 专家重置密码
   export function getUserByUserId(params) {
    return fetch({
      url: '/Service/Api/jd?service=ManageUserService&method=getUserByUserId&param=GetUserByUserIdParam',
      method: "post",
      data: params
    });
  }


// WEBPACK FOOTER //
// ./src/api/pgMent/userMent.js